var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmojiPicker(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.97396 18.9596C5.04062 18.9596 1.01562 14.943 1.01562 10.0013C1.01562 5.05964 5.04062 1.04297 9.97396 1.04297C14.9073 1.04297 18.9323 5.05964 18.9323 10.0013C18.9323 14.943 14.9156 18.9596 9.97396 18.9596ZM9.97396 2.29297C5.72396 2.29297 2.26562 5.7513 2.26562 10.0013C2.26562 14.2513 5.72396 17.7096 9.97396 17.7096C14.224 17.7096 17.6823 14.2513 17.6823 10.0013C17.6823 5.7513 14.224 2.29297 9.97396 2.29297Z",
    fill: "#667085"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99925 16.044C8.20758 16.044 6.52425 15.169 5.49925 13.694C5.29925 13.4107 5.37425 13.019 5.65758 12.8274C5.94091 12.6274 6.33258 12.7024 6.52425 12.9857C7.31591 14.119 8.61591 14.8024 9.99925 14.8024C11.3826 14.8024 12.6826 14.1274 13.4742 12.9857C13.6742 12.7024 14.0576 12.6357 14.3409 12.8274C14.6242 13.0274 14.6909 13.4107 14.4992 13.694C13.4742 15.169 11.7909 16.044 9.99925 16.044Z",
    fill: "#667085"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmojiPicker);
export default __webpack_public_path__ + "static/media/emoji-picker.0749e5d9dbdc951f59c02538cbc8f6fe.svg";
export { ForwardRef as ReactComponent };